export default "__VITE_ASSET__CmN35kqM__"